import React from "react";
import {
  Container,
  Box,
  Typography,
  Grid,
  Button,
  Paper,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import LocationOnIcon from "@material-ui/icons/LocationOn";

const useStyles = makeStyles((theme) => ({
  container: {
    background: "#fff",
    padding: "3rem 2rem",
    borderRadius: "16px",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
    maxWidth: "900px",
    margin: "2rem auto",
    textAlign: "center",
  },
  title: {
    fontWeight: "bold",
    fontSize: "1.8rem",
    marginBottom: "1rem",
  },
  subtitle: {
    fontSize: "1.1rem",
    marginBottom: "0.5rem",
  },
  infoText: {
    color: "#666",
    fontSize: "0.95rem",
    marginBottom: "2rem",
  },
  paper: {
    padding: "1.5rem",
    backgroundColor: "#f9fafb",
    borderRadius: "8px",
    textAlign: "left",
    display: "flex",
    alignItems: "flex-start",
    gap: "0.5rem",
  },
  locationText: {
    fontWeight: "bold",
    marginBottom: "0.5rem",
  },
  contactText: {
    fontSize: "0.95rem",
    color: "#333",
  },
  button: {
    marginTop: "2rem",
    backgroundColor: theme.palette.primary.main,
    color: "#fff",
    padding: "0.75rem 1.5rem",
    borderRadius: "8px",
    textTransform: "none",
    fontWeight: "bold",
    "&:hover": {
      backgroundColor: theme.palette.primary.dark,
    },
  },
}));

const IntroPatrick = () => {
  const classes = useStyles();

  return (
    <section>
      <Container className={classes.container}>
        <Typography className={classes.title}>ZEN workshop®</Typography>
        <Typography className={classes.subtitle}>
          Patrick Caillier a le plaisir de vous informer qu’il a repris son
          activité Ikdo et Zen Workshop en 2025.
        </Typography>
        <Typography className={classes.infoText}>
          La création d’Ikdo remonte à 2006. En 2021, l’activité avait ralenti
          pour des raisons de santé et la pandémie.
        </Typography>

        <Grid container spacing={3} justifyContent="center">
          <Grid item xs={12} md={6}>
            <Paper className={classes.paper}>
              <LocationOnIcon color="primary" />
              <div>
                <Typography className={classes.locationText}>
                  Soins individuels Ikdo
                </Typography>
                <Typography className={classes.contactText}>
                  46 rue Maryse Bastié, Lambersart
                </Typography>
                <Typography className={classes.contactText}>
                  Réservation sur Resalib
                </Typography>
              </div>
            </Paper>
          </Grid>
          <Grid item xs={12} md={6}>
            <Paper className={classes.paper}>
              <LocationOnIcon color="primary" />
              <div>
                <Typography className={classes.locationText}>
                  Soins & formations Zen Workshop
                </Typography>
                <Typography className={classes.contactText}>
                  1 rue de l’Église, Cormont
                </Typography>
                <Typography className={classes.contactText}>
                  07 86 99 59 40
                </Typography>
              </div>
            </Paper>
          </Grid>
        </Grid>

        <Typography style={{ marginTop: "2rem", fontSize: "1rem" }}>
          À bientôt dans ces nouveaux lieux !
        </Typography>

        <Button className={classes.button}>
          <a
            href="https://www.resalib.fr/praticien/163-ikdo-somatotherapeute-lambersart"
            target="_blank"
          >
            Réserver une séance
          </a>
        </Button>
      </Container>
    </section>
  );
};

export default IntroPatrick;
